import React from 'react';
import { formatCurrency } from '../../utils/subscriptionHelpers';

/**
 * Original amount with strikethrough, adjusted amount directly below.
 * Used by payment calendar, user details, payment summary, and student card.
 */
export const AdjustedAmount: React.FC<{
  original: number;
  adj?: number;
  originalClassName?: string;
  align?: 'end' | 'start';
  /** `stack` = original above adjusted (default). `inline` = side by side. */
  layout?: 'stack' | 'inline';
}> = ({ original, adj = 0, originalClassName = '', align = 'end', layout = 'stack' }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: layout === 'inline' ? 'row' : 'column',
      alignItems: layout === 'inline' ? 'baseline' : align === 'end' ? 'flex-end' : 'flex-start',
      gap: layout === 'inline' ? '8px' : '2px',
    }}
  >
    <span
      className={originalClassName}
      style={adj !== 0 ? { textDecoration: 'line-through', color: '#9ca3af', fontSize: '12px' } : undefined}
    >
      {formatCurrency(original)}
    </span>
    {adj !== 0 && (
      <span style={{ fontSize: '14px', fontWeight: 700, color: adj < 0 ? '#22c55e' : '#ef4444' }}>
        {formatCurrency(original + adj)}
      </span>
    )}
  </div>
);

export default AdjustedAmount;
